module.exports = __webpack_public_path__ + "img/ios_model_1000.3410bd6f.png";